<template>
    <v-card class="lighten-5" flat>
        <v-card-title class="grey lighten-3">
            <h4 class="topic">Condições comerciais</h4>
        </v-card-title>

        <p class="info-color mt-3">Observações</p>
        <v-textarea class="mt-2" outline placeholder="Inserir observações" no-resize counter v-model="projeto.observacoes" rows="4">
        </v-textarea>

        <v-layout row wrap>
            <!-- <v-flex d-flex xs12 sm6>
                <v-radio-group label="Modo de pagamento"
                               v-model="projeto.modoPagamento"
                               column
                               @change="atualizaValorParcelas">
                    <v-radio label="À vista" value="0"></v-radio>
                    <v-radio label="Financiamento Sol Agora" value="1"></v-radio>
                    <v-radio label="Cartão de Crédito" value="2"></v-radio>
                </v-radio-group>
            </v-flex>

            <v-flex v-if="projeto.modoPagamento == '1'" d-flex xs12 sm12>

                <v-text-field type="text" label="CPF" v-model="projeto.cliente.documento" :disabled="true" style="color: #bbbbbb"></v-text-field>

                <v-btn class="justify-center"
                       color="primary"
                       @click="simularParcela()">
                    SIMULAR
                </v-btn>
            </v-flex>


            <div class="row" v-if="projeto.modoPagamento == '2'">
                <div class="col-md-12">
                    <div class="row text-center" style="padding-top: 10px;">
                        <h4>
                            <strong>
                                Cartões de crédito
                            </strong>
                        </h4>
                        <h5>
                            Em até 12x com juros*
                        </h5>
                    </div>
                    <div scope="col-bandeiras" class="row text-center">
                        <div class="text-flag">
                            <h5>
                                Selecione a bandeira:
                            </h5>
                        </div>
                        <ul class="nav nav-tabs" role="tablist">
                            <li role="presentation" :class="{ active: bandeira == 1 }"><a @click="bandeiraAtiva(1)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Visa.png" style="max-width:50px" /></i></a></li>
                            <li role="presentation" :class="{ active: bandeira == 2 }"><a @click="bandeiraAtiva(2)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Master.png" style="max-width:50px" /></i></a></li>
                            <li role="presentation" :class="{ active: bandeira == 3 }"><a @click="bandeiraAtiva(3)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Elo.png" style="max-width:50px" /></i></a></li>
                            <li role="presentation" :class="{ active: bandeira == 4 }"><a @click="bandeiraAtiva(4)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Hipercard.png" style="max-width:50px" /></i></a></li>
                            <li role="presentation" :class="{ active: bandeira == 5 }"><a @click="bandeiraAtiva(5)"><i class="image-bandeira" aria-hidden="true"><img src="/assets/images/logo-bandeiras/Amex.png" style="max-width:50px" /></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div style="padding-top: 10px;" class="row text-center">
                <Loader v-if="loadingParcelas" />
                <h5 style="padding-top: 10px;" v-if="loadingParcelas">Carregando simulação das parcelas...</h5>
            </div>

            <v-flex d-flex xs12 sm12>
                <v-select :items="valoresParcelas"
                          item-text="label"
                          item-value="valor"
                          label="Valores das Parcelas"
                          v-model="projeto.cliente.parcelaSelecionada"
                          required return-object>
                </v-select>
            </v-flex> -->

            <div class=" row">
                <v-flex d-flex xs12 sm6>
                    <v-text-field type="number" label="Prazo de entrega" suffix="Dias"
                        v-model="projeto.prazoEntrega"></v-text-field>
                </v-flex>
            </div>

        </v-layout>
    </v-card>
</template>

<style type="text/css">
.shape {
    border-style: solid;
    border-width: 0 70px 40px 0;
    float: right;
    height: 0px;
    width: 0px;
    -ms-transform: rotate(360deg);
    /* IE 9 */
    -o-transform: rotate(360deg);
    /* Opera 10.5 */
    -webkit-transform: rotate(360deg);
    /* Safari and Chrome */
    transform: rotate(360deg);
}

.offer {
    background: #fff;
    border: 1px solid #fff;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    margin: 15px 0;
    overflow: hidden;
}

.offer:hover {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: rotate scale(1.1);
    -webkit-transition: all 0.4s ease-in-out;
    -moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
}

.shape {
    border-color: rgba(255, 255, 255, 0) #d9534f rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);
}

.offer-radius {
    border-radius: 7px;
}

.offer-danger {
    border-color: #d9534f;
}

.offer-danger .shape {
    border-color: transparent #d9534f transparent transparent;
}

.offer-success {
    border-color: #5cb85c;
}

.offer-success .shape {
    border-color: transparent #5cb85c transparent transparent;
}

.offer-default {
    border-color: #999999;
}

.offer-default .shape {
    border-color: transparent #999999 transparent transparent;
}

.offer-primary {
    border-color: #428bca;
}

.offer-primary .shape {
    border-color: transparent #428bca transparent transparent;
}

.offer-info {
    border-color: #5bc0de;
}

.offer-info .shape {
    border-color: transparent #5bc0de transparent transparent;
}

.offer-warning {
    border-color: #f0ad4e;
}

.offer-warning .shape {
    border-color: transparent #f0ad4e transparent transparent;
}

.shape-text {
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    position: relative;
    right: -40px;
    top: 2px;
    white-space: nowrap;
    -ms-transform: rotate(30deg);
    /* IE 9 */
    -o-transform: rotate(360deg);
    /* Opera 10.5 */
    -webkit-transform: rotate(30deg);
    /* Safari and Chrome */
    transform: rotate(30deg);
}

.offer-content {
    padding: 0 20px 10px;
}

@media (min-width: 487px) {
    .container {
        max-width: 750px;
    }

    .col-sm-6 {
        width: 50%;
    }
}

@media (min-width: 900px) {
    .container {
        max-width: 970px;
    }

    .col-md-4 {
        width: 33.33333333333333%;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1170px;
    }

    .col-lg-3 {
        width: 25%;
    }
}
</style>

<script>
import { mapGetters } from "vuex";
import SimulationSolagora from "../partials/sol-agora/SimulationSolAgora.vue";
import axios from "axios";
import { convertNumberToReal } from "../../Utils/formatNumber";

import FormHelper from "@/components/partials/FormHelper.vue";
import SolAgoraService from "@/services/SolAgoraService";

const respostaPadraoErroGenerico =
    "Serviço indisponível, tente novamente mais tarde.";

    export default {
        name: "ProjectCommercialConditions",
        computed: mapGetters(["projeto", "parcelas", "valoresParcelas"]),
        components: { SimulationSolagora, FormHelper, },
        created: function () {
            this.atualizaValorParcelas();
        },
        methods: {
            setValoresParcelas: function (parcelas) {
                this.$store.commit("setValoresParcelas", parcelas);
                if (parcelas.length > 0)
                    this.projeto.cliente.parcelaSelecionada = parcelas[0];
            },

        bandeiraAtiva(numeroBandeira) {

            this.bandeira = numeroBandeira;
            this.getValoresParcelamento(this.projeto.valorEUP.replace("R$ ", "").replace(".", "").replace('.', '').replace(",", "."), this.bandeira);

        },
        getValoresParcelamento(valorDoProduto, bandeira) {
            this.loadingParcelas = true;

            if (typeof valorDoProduto == "string") {
                valorDoProduto = parseFloat(valorDoProduto);
            }
            let session = JSON.parse(localStorage.getItem('usuarioLogado'));

            const codBandeira = parseInt(bandeira);

            const codigoPedido = session.CodigoPedido;
            axios
                .post(
                    this.$apiUrl + "PagamentoCartao.svc/CreditCardProductInterestRates",
                    { codigoPedido: codigoPedido, codigoProduto: this.projeto.produto, valorProduto: valorDoProduto, bandeira: codBandeira },
                    { withCredentials: true })
                .then((response) => {
                    if (response.data) {
                        const optionsParcela = response.data.map((x) => (
                            {
                                quantidade: x.InstallmentNumber,
                                valor: (x.FinalValue / x.InstallmentNumber),
                                label: x.InstallmentNumber + ' x ' + convertNumberToReal(x.FinalValue / x.InstallmentNumber),
                                ...x
                            }));

                        this.setValoresParcelas(optionsParcela);

                        if (optionsParcela.length > 0)
                            this.projeto.cliente.parcelaSelecionada = optionsParcela[0];

                        this.loadingParcelas = false;
                    }
                });
        },

        convertToReal(number) {
            return convertNumberToReal(number);
        },
        simularParcela: async function () {
            try {
                this.loadingParcelas = true;
                const auth = await SolAgoraService.GetToken({ apiUrl: this.$apiUrl });

                this.projeto.cliente.parcelaSelecionada = null

                if (!auth) {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return false;
                }

                const token = auth.data.AccessToken;

                const documento = this.projeto.cliente.documento;

                const res = await SolAgoraService.OpenSimulate({
                    apiUrl: this.$apiUrl,
                    token: token,
                    price: this.projeto.valorEUP.replace('.', '').replace(',', '.'),
                    monthly_income: 1000000,
                    document: documento,
                });

                if (!res) {
                    swal({
                        title: "Aviso",
                        text: respostaPadraoErroGenerico,
                        icon: "warning",
                    });
                    return;
                }

                if (res.message) {
                    swal({
                        title: "Aviso",
                        text: res.message,
                        icon: "warning",
                    });
                    return;
                }

                if (res.data.Parcelas && res.data.Parcelas.length) {

                    const optionsParcela = res.data.Parcelas.map((x) => ({ quantidade: x.Prazo, valor: x.VlrParcela, label: `${x.Prazo} x R$ ${x.VlrParcela.toFixed(2).replace('.', ',')}`, ...x }));

                    this.setValoresParcelas(optionsParcela);

                    if (optionsParcela.length > 0)
                        this.projeto.cliente.parcelaSelecionada = optionsParcela[0];

                }
            }
            finally {
                this.loadingParcelas = false;
            }
        },

        atualizaValorParcelas: function () {
            this.setValoresParcelas([]);

            if (this.projeto.modoPagamento == '0') {
                const optionsParcela =
                {
                    quantidade: 1,
                    valor: this.projeto.valorEUP.replace('.', '').replace(',', '.'),
                    label: 1 + ' x R$ ' + this.projeto.valorEUP
                };

                this.setValoresParcelas(optionsParcela);
            }
        }
    },

    data() {
        return {
            showSimularSolAgora: false,
            prazoRules: [
                v => !!v || 'Prazo de entrega é obrigatório',
                v => v >= 0 || 'O prazo de entrega deve ser um valor positivo'
            ],
            parcelaRules: [
                v => !!v || 'A parcela é obrigatória'
            ],
            productInstallments: [],
            loadingParcelas: false,
            parcelaSelecionada: null,
            optionsCliente: [],
            optionsParcela: [],
            loader: false,
        }
    }
}
</script>
